import React from 'react';
import { translate } from '../../Services/translation';
import { CustomCarousel } from '../CustomCarousel';

const CaseBlock = ({ cases }) => {
    return (
        <div>
            <CustomCarousel>
                {cases.map((value, index) => (
                    <a
                        href={value.url}
                        className="caseblock-content-rightwrapper-content"
                        key={index}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: value.imageData.html,
                            }}
                        />

                        <div className="caseblock-content-rightwrapper-content-textwrapper">
                            {value.preTitle && (
                                <h2 className="caseblock-content-rightwrapper-content-textwrapper-pretitle">
                                    {value.preTitle}
                                </h2>
                            )}

                            {(() => {
                                const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'];
                                const TitleTag = allowedTags.includes(value.titleTag) ? value.titleTag : 'h3';
                                return (
                                    <TitleTag className="caseblock-content-rightwrapper-content-textwrapper-title">
                                        {value.title}
                                    </TitleTag>
                                );
                            })()}

                            <div
                                className="caseblock-content-rightwrapper-content-textwrapper-description"
                                dangerouslySetInnerHTML={{
                                    __html: value.description,
                                }}
                            ></div>
                        </div>

                        <div className="caseblock-content-rightwrapper-content-textwrapper-button">
                            <div className="link">
                                <p className="caseblock-content-rightwrapper-content-textwrapper-button-text">
                                    {translate('cardblock.readmore.button')}
                                </p>
                                <i className="caseblock-content-rightwrapper-content-textwrapper-button-icon"></i>
                            </div>
                        </div>
                    </a>
                ))}
            </CustomCarousel>
        </div>
    );
};

export default CaseBlock;
